import axios from 'axios';
import CryptoJS from "crypto-js";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const SECRET = process.env.REACT_APP_CRYPTO_SECRET;

if (!SECRET) {
  throw new Error("❌ REACT_APP_CRYPTO_SECRET missing in .env");
}



const adminAxios = axios.create({ baseURL: `${API_URL}/admin` });




const key = CryptoJS.SHA256(SECRET);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

// 🔐 ENCRYPT
const encrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return { data: encrypted.toString() };
};

// 🔓 DECRYPT
const decrypt = (payload) => {
  const decrypted = CryptoJS.AES.decrypt(
    payload.data,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};


// ===============================
// 🔐 REQUEST INTERCEPTOR
// ===============================
// adminAxios.interceptors.request.use((config) => {
//   const token = sessionStorage.getItem('adminToken');

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   // 🔥 ENCRYPT BODY
//   // if (config.data && Object.keys(config.data).length > 0) {
//   if (config.data && !(config.data instanceof FormData)) {
//     const encrypted = encrypt(config.data);

//     config.headers['x-encrypted-data'] = JSON.stringify(encrypted);
//     config.data = {};
//   }

//   return config;
// });


adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.method?.toLowerCase() === "get") {
    return config;
  }

  if (config.data instanceof FormData) {
    console.log("⏭️ Admin Encryption skipped (FormData)");
    return config;
  }

  if (config.data) {
    const encryptedPayload = encrypt(config.data);

    config.headers["x-encrypted-data"] =
      JSON.stringify(encryptedPayload);

    config.data = {};
  }
//   if (config.data) {
//   const encryptedPayload = encrypt(config.data);

//   config.data = {
//     encryptedData: JSON.stringify(encryptedPayload)
//   };
// }

  return config;
});

// ===============================
// 🔐 RESPONSE INTERCEPTOR
// ===============================

adminAxios.interceptors.response.use(
  (response) => {
    try {
      // ✅ NEW: body based decrypt
      if (response.data?.encrypted) {
        const decrypted = decrypt(response.data.data);
        response.data = JSON.parse(decrypted);
      }
    } catch (err) {
      console.error("❌ Decryption failed:", err.message);
    }

    return response;
  },
  (error) => Promise.reject(error)
);


// ==========================================
// 🔐 AUTH & DASHBOARD ROUTES
// ==========================================
export const adminLogin = (data) => adminAxios.post('/login', data);
export const getDashboardStats = () => adminAxios.get('/dashboard');


// ==========================================
// 👥 USER MANAGEMENT ROUTES (Candidates, Casting Directors, etc.)
// ==========================================
export const getAdminUsers = (roleCode) => adminAxios.get(`/users/${roleCode}`);
export const createAdminUser = (data) => adminAxios.post('/users', data);
export const updateAdminUser = (id, data) => adminAxios.put(`/users/${id}`, data);
export const deleteAdminUser = (id) => adminAxios.delete(`/users/${id}`);
export const suspendAdminUser = (id) => adminAxios.patch(`/users/${id}/suspend`);



// ==========================================
// 📁 PROJECT MANAGEMENT ROUTES
// ==========================================
export const getAdminProjects = () => adminAxios.get('/projects');
export const getAdminProjectById = (id) => adminAxios.get(`/projects/${id}`);
export const createAdminProject = (data) => adminAxios.post('/projects', data);
export const updateAdminProject = (id, data) => adminAxios.put(`/projects/${id}`, data);
export const deleteAdminProject = (id) => adminAxios.delete(`/projects/${id}`);
export const toggleProjectStatus = (id) => adminAxios.patch(`/projects/${id}/toggle-status`);


// ==========================================
// 🎭 ROLE MANAGEMENT ROUTES
// ==========================================
export const getAdminRoles = () => adminAxios.get('/roles');
export const getAdminRoleById = (id) => adminAxios.get(`/roles/${id}`);
export const createAdminRole = (data) => adminAxios.post('/roles', data);
export const updateAdminRole = (id, data) => adminAxios.put(`/roles/${id}`, data);
export const deleteAdminRole = (id) => adminAxios.delete(`/roles/${id}`);
export const toggleRoleStatus = (id) => adminAxios.patch(`/roles/${id}/toggle-status`);

// ==========================================
// 🎭 LookUp
// ==========================================


export const getAdminLookups = () => adminAxios.get('/lookups/list');
export const saveAdminLookup = (data) => adminAxios.post('/lookups/save', data);
export const deleteAdminLookup = (groupName) =>
  adminAxios.delete(`/lookups/${groupName}`);


export const fetchContactSubmissionsApi = () => adminAxios.get('/contact');
export const fetchContactSubmissionDetailsApi = (id) => adminAxios.get(`/contact/${id}`);

export const getAdminAuditions = () => adminAxios.get('/audition-list');

export const getNotificationLogs = () =>  adminAxios.get("/notification-logs");

//  --- Cost Pricing --- //
export const fetchCosts = async () => { const res = await adminAxios.get('/cost-list');
  return res.data;
};
export const fetchCostById = async (name) => { const res = await adminAxios.get(`/cost/${name}`);
  return res.data;
};
export const createCost = (data) => adminAxios.post('/cost-save', data);
export const updateCost = (name, data) => adminAxios.post('/cost-save', data);
export const deleteCost = (name) =>  adminAxios.delete(`/cost/${name}`);
export const getCostTypes = async () => {  const res = await adminAxios.get('/cost-types');
  return res.data;
};
export const fetchCostOptions = async (type) => { const res = await adminAxios.get(`/cost-options/${type}`);
  return res.data;
};


export const getAllCoupons = () => adminAxios.get('/coupons/list');
export const getCouponById = (id) => adminAxios.get(`/coupons/details/${id}`);
export const createCoupon = (data) => adminAxios.post('/coupons/create', data);
export const updateCoupon = (id, data) => adminAxios.put(`/coupons/update/${id}`, data);
export const deleteCoupon = (id) => adminAxios.delete(`/coupons/delete/${id}`);
export const redeemCoupon = (code, userId) => adminAxios.post('/coupons/redeem', { code, userId });

// ========================================== // ⭐ TESTIMONIAL ROUTES // ==========================================

export const getAllTestimonials = () => adminAxios.get('/testimonials/list');
export const getTestimonialById = (id) => adminAxios.get(`/testimonials/details/${id}`);
export const createTestimonial =(data) => adminAxios.post('/testimonials/create', data);
export const updateTestimonial =(id, data) => adminAxios.put( `/testimonials/update/${id}`,data);
export const deleteTestimonial =(id) => adminAxios.delete( `/testimonials/delete/${id}`);

// export const getDashboardStats =
// () => adminAxios.get('/dashboard');


export const getPaymentGatewayConfig = () =>
  adminAxios.get('/payment-gateway');

export const savePaymentGatewayConfig = (data) =>
  adminAxios.post('/payment-gateway/save', data);

// export const getPaymentLogs = () =>
//   adminAxios.get('/payment-logs/list');

// export const getPaymentLogDetails = (id) =>
//   adminAxios.get(`/payment-logs/${id}`);

export const getPaymentGatewayConfigs = () =>
  adminAxios.get('/payment-gateway/list');

export const getPaymentGatewayConfigById = (id) =>
  adminAxios.get(`/payment-gateway/${id}`);
export const updatePaymentGatewayConfig = (id, data) =>
  adminAxios.put(`/payment-gateway/${id}`, data);

export const deletePaymentGatewayConfig = (id) =>
  adminAxios.delete(`/payment-gateway/${id}`);
export const getLookupByGroup = (groupIdentifier) => 
  adminAxios.get(`/payment-gateway/lookups/${groupIdentifier}`);

// export const migrateDataApi = (type, data) => adminAxios.post('migration/migrate', { type, data });
// export const migrateDataApi = (formData) => adminAxios.post('/migration/migrate', formData);
export const migrateUsersApi = (formData) => adminAxios.post('/migration/users', formData);
export const migrateProjectsApi = (formData) => adminAxios.post('/migration/projects', formData);
export const migrateRolesApi = (formData) => adminAxios.post('/migration/roles', formData);

// ==========================================
// 🟢 NEW: WEBHOOK LOGS API ROUTES
// ==========================================
export const getWebhookLogs = (params) => adminAxios.get('/webhook-logs', { params });
export const getWebhookLogDetails = (id) =>  adminAxios.get(`/webhook-logs/${id}`);
// ==========================================

// 🟢 NEW: PAYMENT RECONCILIATION API ROUTES
// ==========================================
export const getReconciliationList = () => adminAxios.get('/payment-reconciliation/list');
export const getRefundedReconciliationList = () => adminAxios.get('/payment-reconciliation/refunded-list');
export const processSingleReconciliation = (id, data) => adminAxios.post(`/payment-reconciliation/${id}/reconcile`, data);
// ==========================================

// ==========================================
// 🟢 NEW: PAYMENT LOGS & MANUAL APPROVAL ROUTES
// ==========================================
export const getPaymentLogs = (params) =>  adminAxios.get('/payment-logs/list', { params });
export const getPaymentLogDetails = (id) =>  adminAxios.get(`/payment-logs/${id}`);
export const approvePaymentLog = (id, data) => adminAxios.post(`/payment-logs/${id}/approve`, data);
// ==========================================


// ==========================================
// 🟢 NEW: USER ACTIVITY LOGGER API ROUTES
// ==========================================
export const getUserActivityLogs = (params) => adminAxios.get('/user-activity-logs/list', { params });
export const getAdminLeads = (params) => adminAxios.get('/leads', { params });
export const updateLeadFollowup = (data) => adminAxios.put('/leads/update-followup', data);
export const deleteAdminLead = (id) => adminAxios.delete(`/leads/${id}`)

// ==========================================
// 🏢 POC / STAFF / TEAM MANAGEMENT ROUTES
// ==========================================
export const getPocList = (params) => adminAxios.get('/pocs/list', { params });
export const getPocsByParentUser = (parentUserId) => adminAxios.get(`/pocs/parent/${parentUserId}`);
export const getPocById = (id) => adminAxios.get(`/pocs/${id}`);
export const createPoc = (data) => adminAxios.post('/pocs/create', data);
export const updatePoc = (id, data) => adminAxios.put(`/pocs/update/${id}`, data);
export const deletePoc = (id) => adminAxios.delete(`/pocs/delete/${id}`);
export const togglePocReleaseStatus = (id) => adminAxios.patch(`/pocs/${id}/toggle-release`);
export const updatePocPermissions = (id, permissions) => adminAxios.patch(`/pocs/${id}/permissions`, { permissions });


// 💳 PAYMENT SETTLEMENT ROUTES
export const saveDirectorBankDetails = (data) => adminAxios.post('/settlement/bank-details', data);
export const getDirectorBankDetails = (userId) => adminAxios.get(`/settlement/bank-details/${userId}`);
export const getAllBankDetails = () => adminAxios.get('/settlement/casting-directors?onlyConfigured=true');
export const getUnsettledTransactions = (castingDirectorId) => adminAxios.get(`/settlement/unsettled-transactions?castingDirectorId=${castingDirectorId || ''}`);
export const initiateSettlementBatch = (data) => adminAxios.post('/settlement/initiate-batch', data);
export const completeSettlementBatch = (data) => adminAxios.post('/settlement/complete-batch', data);
export const getSettlementHistory = (params) => adminAxios.get('/settlement/history', { params });
export const getCDSettlements = (params) => adminAxios.get('/settlement/history', { params });
export const getCDSettlementDetails = (id) => adminAxios.get(`/settlement/details/${id}`);
export const getCastingDirectorsList = () => adminAxios.get('/settlement/casting-directors');
export const deleteDirectorBankDetails = (userId) => adminAxios.delete(`/settlement/bank-details/${userId}`); // 👈 NEW


export { adminAxios };
export default adminAxios; 